// @ts-check
import { Container, Grid } from '~/design-system';

/**
 *
 * @param {object} props
 * @param {number} [props.columns]
 * @param {number} [props.gap]
 * @param {React.ReactNode} [props.children]
 * @returns
 */
export default function Main({ children, columns, gap, ...rest }) {
  return (
    <Container sx={{ maxWidth: 960 }} {...rest}>
      <Grid as="main" columns={columns} gap={gap}>
        {children}
      </Grid>
    </Container>
  );
}
